import { trailingSlashEnd } from "./utils";

export const modalState = {
  AUTH: "auth",
  REGISTRATION: "registration",
  RELEASE_TEXT: "releaseText",
  TRACK_INFO: "trackInfo",
  RELEASE_PODCAST_INFO: "releasePodcastInfo",
  TOGGLE_STREAM: "toggleStream",
  CONFIRM_EXIT: "confirmExit",
  NONE: null,
};

export const SECOND = 1000;
export const MINUTE = SECOND * 60;
export const HOUR = MINUTE * 60;

export const guestName = "Гость";

export const registrationMessage = {
  email: "Почта написана с ошибками",
  password: "Пароль слишком короткий. Нужно хотя бы 6 символов",
};

export const ADVERTISING_NAME = "ADV";
export const WEATHER_NAME = "Погода";
export const NEWS_NAME = "Новости";

export const SYSTEM_TRACK_NAMES = [ADVERTISING_NAME, WEATHER_NAME, NEWS_NAME];

export const defaultRadioInfoByType = {
  rock: {
    currentTrack: "",
    nameStream: "Рок",
    color: "#F7E56E",
    icon: "./",
    isPlaying: false,
    loading: false,
    aboutTrack: {
      _id: "",
      title: "",
      track: "",
      artist: "",
      wikipedia: "",
      genre: "",
      release: "",
      cover: { big: "", small: "" },
      userRating: null,
      spotify: {
        url: "",
      },
      yandexMusic: {
        url: "",
      },
      appleMusic: {
        url: "",
      },
    },
    icons: {
      big: "",
      medium: "",
      small: "",
    },
  },
  mc: {
    currentTrack: "",
    nameStream: "Металкор",
    color: "#FB8056",
    icon: "./",
    isPlaying: false,
    loading: false,
    aboutTrack: {
      _id: "",
      title: "",
      track: "",
      artist: "",
      wikipedia: "",
      genre: "",
      release: "",
      cover: { big: "", small: "" },
      userRating: null,
      spotify: {
        url: "",
      },
      yandexMusicId: {
        url: "",
      },
      appleMusic: {
        url: "",
      },
    },
    icons: {
      big: "",
      medium: "",
      small: "",
    },
  },
  lite: {
    currentTrack: "",
    nameStream: "Лайт",
    color: "#4E9FDA",
    icon: "./",
    isPlaying: false,
    loading: false,
    aboutTrack: {
      _id: "",
      title: "",
      track: "",
      artist: "",
      wikipedia: "",
      genre: "",
      release: "",
      cover: { big: "", small: "" },
      userRating: null,
      spotify: {
        url: "",
      },
      yandexMusicId: {
        url: "",
      },
      appleMusic: {
        url: "",
      },
    },
    icons: {
      big: "",
      medium: "",
      small: "",
    },
  },
};

export const LOCAL_STORAGE_QUESTIONS_KEY = "questions";

export const ADMIN_URL = trailingSlashEnd(process.env.REACT_APP_ADMIN_URL);

export const isTouchDevice =
  "ontouchstart" in window || navigator.maxTouchPoints > 0;
